/**
* @description
* # name controller --> ambitsListController
* # As Controller --> ambitsList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class ambitsListController {
	constructor($scope,ambitsServices,coresServices,ngNotify,UserInfoConstant,$state,$filter,) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = ambitsServices.services;
		this.coresServices = coresServices.services;
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.ambitSelect = null
		

		$scope.UserInfoConstant = UserInfoConstant;
		$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.USER_ID = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.coresServices.getCores({ concept_id: this.conceptId}).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.cores = []
				this.coresList = dataReturn.results;
				for (let i in this.coresList){
					this.cores.push({
						title: this.coresList[i].ds_name,
						id_code: this.coresList[i].id_code,
						cod: "Código: " + this.coresList[i].id_code,
						ambitName: this.coresList[i].ambit ? this.coresList[i].ambit.ds_name : null,
						badges: [
							{
								label: ( (this.coresList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.coresList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

		this.getAmbits()
	}

	getAmbits(){
		this.services.getAmbits().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.ambits = []
				this.ambitsList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	onClick(item){
		this.coreId=item.id_code;
		this.coreName=item.title;
		this.getDetailsFunction({core_id:this.coreId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.coresServices.getCoreDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.core = dataReturn.results;
				this.$scope.ambitSelect = this.core.id_ambit
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({core_id : this.coreId});
		
	}

	saveEdit(){
		if(this.coreName === null || this.coreName === '') {
			this.ngNotify.set('Indique nombre','warn')
			return
		}

		if(this.$scope.ambitSelect === null) {
			this.ngNotify.set('Seleccione un Ambito','warn')
			return
		}
		
		const params = {
			core_id: this.coreId,
			name: this.coreName,
			user_id: this.USER_ID,
			ambit_id: this.$scope.ambitSelect
		}

		this.coresServices.updateCores(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Núcleo','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de núcleo se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de núcleo ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
ambitsListController.$inject=['$scope', 'ambitsServices', 'coresServices', 'ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/cores/list/coresListController.js